module.exports = __webpack_public_path__ + "static/img/BU02PB.207d7bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU02PB.jpg
// module id = CZOV
// module chunks = 1